import React from "react";

export default function SinglePie({ effectPerc }) {
  return (
    <>
      <div className="base-crcl">
        <div className="clred-crcl"></div>
        <div
          className="cut-crcl"
          style={{
            backgroundImage: `conic-gradient(rgba(255, 255, 255, 0) ${effectPerc}, #1b1d2d ${effectPerc})`,
          }}
        ></div>
        <div className="border-nr-crcl"></div>
        <div className="base-nr-crcl"></div>
        <div className="perc-nr"> {effectPerc} </div>
      </div>
    </>
  );
}
